<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title(style="width: 100%;")
        v-layout.pa-0.ma-0(row)
          StatusIndicator.ma-2(positive pulse v-if="updateInfo")
          h1.subheading {{ $t('pageHeader.signUps') }} - 10 Days
          v-spacer
          h1.subheading {{ signups.length }}
    v-card-text.list-350
      v-progress-linear(v-if="isLoading" size="70" width="7" indeterminate)
      v-layout(column v-if="!isLoading")
        template(v-for="(row, index) in signups")
          v-layout.pointer(column @click="viewLocationNewTab(row)")
            v-flex.pb-0
              v-layout
                v-flex.font-weight-medium
                  span(v-if="row.organizationID")
                    v-icon.mr-1(medium) business
                  span.caption.list-line {{ row.companyName }} - {{ row.phoneNumber | USPhoneNumber }}
                v-spacer
                v-flex.caption.text-xs-right(color="text--gray") {{ row.createdAt | moment("from", "now") }}
            v-flex.pt-0
              v-layout
                v-flex
                  span.caption.list-line {{ row.firstName }}, {{ row.lastName }}

          v-divider(v-if="index + 1 < signups.length" :key="index")

</template>

<script>
import locationService from '../../Location/service.js'
import { StatusIndicator } from 'vue-status-indicator'
// import 'vue-status-indicator/styles.css'

export default {
  data() {
    return {
      signups: [],
      isLoading: true,
      updateInfo: false,
    }
  },
  mounted() {
    this.getAll()
  },
  components: {
    StatusIndicator,
  },
  methods: {
    viewLocationNewTab(row) {
      this.$router.push({ path: `/organization/profile/${row.organizationID}` })
    },
    getAll() {
      let proFilter = {
        fromDate: this.$moment(new Date()).subtract(10, 'days').format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(new Date()).format("MM/DD/YYYY h:m a")
      }
      return locationService.getSignUp(proFilter).then(response => {
        this.signups = response.data;
        this.isLoading = false;
        return response;
      });
    }
  }
}
</script>

<style scoped>
</style>
